/* istanbul ignore file: https://clarifai.atlassian.net/browse/LT-2756 */
import { getEnv, Instance, types as t } from 'mobx-state-tree';
import { createBasePredictionStoreMST, PredictionListMSTLeft } from 'modules/Predictions/mst/basePredictionStore';
import { action, effect } from 'mst-effect';
import type { QueryClient } from 'react-query';
import { tap, map, mergeMap, debounceTime, filter } from 'rxjs';
import { makeWfPredict$ } from 'modules/Predictions/effects';
import { ReactLeft } from 'utils/uiStates/uiStates';
import { either } from 'fp-ts';
import { noop, pipe } from 'utils/fp';

export const ModelOutputSetting = t.model({
  minThreshold: t.optional(t.number, 0),
});

export const WorkflowPredictionsStoreMST = t
  .compose(
    createBasePredictionStoreMST<CF.API.Workflows.Workflow>(),
    t.model({
      ModelOutputSettings: t.map(ModelOutputSetting),
    }),
  )
  .actions((self) => {
    return {
      predict: effect<CF.API.WorkflowOutputs.PostWorkflowPredictBody | undefined>(self, (payload$) =>
        payload$.pipe(
          filter(Boolean),
          tap(() => self.setLoading()),
          debounceTime(120),
          mergeMap(
            makeWfPredict$({
              workflow: self.entity.data,
              getVersionId: () => self.viewState.selectedVersionId,
              queryClient: getEnv<{ queryClient: QueryClient }>(self).queryClient,
            }),
          ),
          map((outputE) =>
            action(() => {
              self.outputE = outputE as unknown as either.Either<
                ReactLeft<PredictionListMSTLeft<CF.API.Workflows.Workflow>>,
                CF.API.ModelOutputs.ModelOutput[]
              >;
              pipe(
                outputE,
                either.fold(noop, () => {
                  self.setLastEligibleNode();
                }),
              );
            }),
          ),
        ),
      ),
      setMinThreshold: (modelId: string, num: number) => {
        self.ModelOutputSettings.set(modelId, { minThreshold: Math.max(0, num) });
      },
    };
  });

export type IWorkflowPredictionStoreMST = Instance<typeof WorkflowPredictionsStoreMST>;
export interface IModelOutputSetting extends Instance<typeof ModelOutputSetting> {}
